import { Box, Button, Dialog, Grid } from "@mui/material";
import { useState } from "react";
import { OperacaoCategoriasProdutosContainer } from "../../../../../produtos/containers/OperacaoCategoriasProdutosContainer";
import { ImprimirAnexoButton } from "../../../../components/ImprimirAnexoButton";
import { MetodoPagamentoSelect } from "../../../../components/MetodoPagamentoSelect";
import { TipoPedido } from "../../../../enum/TipoPedido";
import { CategoriasContainer, ProdutosPaper } from "./styles";
import { useFetchCategorias } from "../../../../../produtos/hooks/useFetchCategorias";
import { CarrinhoMobilePaper } from "../../styles";
import { useTamanhoTela } from "../../../../../core/hooks/useTamanhoTela";
import { TipoGatilhoComanda } from "../../../../enum/TipoGatilhoComanda";
import { IPagamentoPedido } from "../../../../interface/IPagamentoPedido";
import { ProdutosCarrinhoEdicaoContainer } from "../../../../../produtos/containers/ProdutosCarrinhoEdicaoContainer";
import { useOperacaoEdicaoContext } from "../../../../contexts/OperacaoEdicaoContext";
import { Print } from "@mui/icons-material";
import { CheckoutEdicaoPaper } from "../../../../components/CheckoutEdicaoPaper";
import { ClientePaper } from "../../../../components/ClientePaper";
import { CadastrarVincularCliente } from "../../../../../clientes/containers/CadastrarVincularCliente";
import { ICliente } from "../../../../../clientes/interface/ICliente";
import { BotoesAcoesCheckout } from "../../../../components/BotoesAcoesCheckout";
import { FidelidadeCardsWrapper } from "../../../../components/FidelidadeCardsWrapper";
import { RodadasMesaPaper } from "../../../../components/RodadasMesaPaper";

export const OperacaoEdicaoMesa = () => {
    const { modeloTela } = useTamanhoTela();
    const { categorias } = useFetchCategorias();

    const {
        adicionarProduto,
        adicionarProdutosCombo,
        alterarPagamentos,
        aumentarQuantidade,
        diminuirQuantidade,
        removerProduto,
        fecharPedido,
        loading,
        loadingAnexo,
        abrirDrawerPagamento,
        cancelarPedido,
        editarProduto,
        numeroTotalItens,
        produtosSelecionados,
        fluxoContexto,
        pedido,
        gerarAnexosBotaoImprimirComandas,
        abrirDrawerDividir,
        abrirModalImpressao,
        selecionarProduto,
        configuracaoNFCe,
        switchImprimirAutomatico,
        handleSwitchImprimirAutomatico,
        switchNotaFiscal,
        handleSwitchNotaFiscal,
        vincularClientePedido,
        desvincularClientePedido,
        loadingVincularCliente,
        cupons,
        abrirDrawerCupons,
        aplicarCupom,
        recarregarPedido
    } = useOperacaoEdicaoContext();

    const [modalVincularClienteAberto, setModalVincularClienteAberto] = useState(false);

    const handleAlterarPagamento = (pagamento?: IPagamentoPedido) => {
        if (!pagamento?.metodoPagamento) {
            alterarPagamentos(undefined);
        } else {
            alterarPagamentos([pagamento]);
        }
    }

    const handleVincularCliente = async (cliente: ICliente) => {
        await vincularClientePedido(cliente);
        setModalVincularClienteAberto(false);
    }

    const abrirModalVincularCliente = () => {
        setModalVincularClienteAberto(true);
    }

    const fecharModalVincularCliente = () => {
        setModalVincularClienteAberto(false);
    }

    const configuracoesComandaCozinha = fluxoContexto
        ?.configuracoesComandas
        ?.filter(config => config.gatilhos.includes(TipoGatilhoComanda.BOTAO_IMPRIMIR));

    return (
        <Grid
            container
            spacing={0}
            sx={{ width: "100%", height: "100%" }}
            justifyContent={"center"}
            alignItems={"center"}
        >
            <>
                <Grid item xs={12} sm={9}>
                    <ProdutosPaper variant="outlined">
                        <CategoriasContainer>
                            <OperacaoCategoriasProdutosContainer
                                categorias={categorias}
                                adicionarProduto={adicionarProduto}
                                adicionarProdutosComboExterno={adicionarProdutosCombo}
                                contexto={TipoPedido.mesa}
                                carrinhoContainer={
                                    <ProdutosCarrinhoEdicaoContainer
                                        categorias={categorias}
                                        produtosCarrinho={pedido?.produtos ?? []}
                                        aumentarQuantidade={aumentarQuantidade}
                                        diminuirQuantidade={diminuirQuantidade}
                                        removerProduto={removerProduto}
                                        editarProduto={editarProduto}
                                        selecionarProduto={selecionarProduto}
                                        produtosSelecionados={produtosSelecionados}
                                    />
                                }
                            />
                        </CategoriasContainer>
                    </ProdutosPaper>
                </Grid>
                <Grid item xs={12} sm={3}>
                    {pedido && (
                        <CheckoutEdicaoPaper
                            loading={loading}
                            valorTotalPedido={pedido?.valorTotal}
                            pedidoSelecionado={pedido?.uuid}
                            numeroTotalItens={numeroTotalItens}
                            numeroPedidoDiario={pedido?.numeroPedidoDiario}
                            opcoes={[
                                {
                                    titulo: "Concluir",
                                    funcao: fecharPedido,
                                    atalho: "F8"
                                },
                                {
                                    titulo: "Dividir pedido",
                                    funcao: abrirDrawerDividir
                                },
                                {
                                    titulo: "Dividir pagamento",
                                    funcao: abrirDrawerPagamento
                                },
                                {
                                    titulo: "Cancelar",
                                    funcao: cancelarPedido
                                }
                            ]}
                        >
                            <ClientePaper
                                cliente={pedido?.cliente}
                                removerCliente={desvincularClientePedido}
                                desabilitar={false}
                                ocultar={false}
                                mesaId={pedido?.mesaId}
                                onVincularCliente={abrirModalVincularCliente}
                            />
                            <RodadasMesaPaper pedido={pedido} recarregar={recarregarPedido} />
                            <FidelidadeCardsWrapper
                                cliente={pedido?.cliente}
                                cupons={cupons}
                                aplicarCupom={aplicarCupom}
                                adicionarProduto={adicionarProduto}
                                categorias={categorias || []}
                                produtos={pedido?.produtos || []}
                            />
                            {configuracoesComandaCozinha?.length ? (
                                <ImprimirAnexoButton
                                    gerarAnexo={() => gerarAnexosBotaoImprimirComandas()}
                                    loading={loadingAnexo}
                                    color={
                                        !produtosSelecionados.length
                                            ? "primary"
                                            : "secondary"
                                    }
                                    titulo={
                                        !produtosSelecionados.length
                                            ? "EMITIR COMANDA(S)"
                                            : `${produtosSelecionados.length} PRODUTO(S) SELECIONADO(S)`
                                    }
                                />
                            ): ''}
                            {modeloTela == "mobile" && (pedido.produtos && pedido.produtos?.length > 0) && (
                                <CarrinhoMobilePaper variant="outlined" sx={{ marginTop: "1rem" }}>
                                    <ProdutosCarrinhoEdicaoContainer
                                        categorias={categorias}
                                        produtosCarrinho={pedido?.produtos ?? []}
                                        aumentarQuantidade={aumentarQuantidade}
                                        diminuirQuantidade={diminuirQuantidade}
                                        removerProduto={removerProduto}
                                        editarProduto={editarProduto}
                                        selecionarProduto={selecionarProduto}
                                        produtosSelecionados={produtosSelecionados}
                                    />
                                </CarrinhoMobilePaper>
                            )}
                            <MetodoPagamentoSelect
                                pagamento={pedido?.pagamentos ? pedido.pagamentos[0] : undefined}
                                onChange={handleAlterarPagamento}
                                valorTotal={pedido.valorTotal}
                            />
                            <BotoesAcoesCheckout
                                switchImprimirAutomatico={switchImprimirAutomatico}
                                handleSwitchImprimirAutomatico={handleSwitchImprimirAutomatico}
                                switchNotaFiscal={switchNotaFiscal}
                                handleSwitchNotaFiscal={handleSwitchNotaFiscal}
                                configuracaoNFCeObrigatorio={configuracaoNFCe?.obrigatorio}
                                quantidadeCupons={cupons.length}
                                abrirDrawerCupons={abrirDrawerCupons}
                                abrirModalComandas={abrirModalImpressao}
                            />
                        </CheckoutEdicaoPaper>
                    )}
                </Grid>
            </>
            <Dialog
                open={modalVincularClienteAberto}
                onClose={fecharModalVincularCliente}
                maxWidth="sm"
                fullWidth
            >
                <CadastrarVincularCliente
                    vincularCliente={handleVincularCliente}
                />
            </Dialog>
        </Grid>
    );
}